import axios from "axios";
import { api_link } from "../config";

export default function requestApi(path, method, data) {
    const url = api_link + path;

    if (method === 'post') {
        const formData = data;
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } else if (method === 'get') {
        return axios.get(url, { params: data });
    } else {
        console.log('error promise');
        return Promise.reject(new Error('Méthode de requête invalide'));
    }
}